export default __webpack_public_path__ + "static/media/top_b.74fcb302.jpg";